/**
 * @param {string} string
 * @returns {string[]} An array of string values
 */
function arrayFromCommaSeparatedValues(string) {
    if (!string) return;

    const values = string.split(',').map(v => {
        if (v) return v.trim();
    });

    return values;
}

module.exports = arrayFromCommaSeparatedValues;
